export default "__VITE_ASSET__BHTI9$hS__"